import { useCallback, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { WalletDetailsCard, WalletDetailsRecord } from './_partials';
import { GET_USER_WALLET } from '../../../graphql/admin_queries';
import useCustomQuery from '../../../network/useCustomQuery';
import { AdminRouteName } from '../../CONSTANTS';

const Wallet = () => {
  const [payload, setPayload] = useState<{balance: number}>();
  const { customerId } = useParams<{ customerId: string }>();
  const { push } = useHistory();
  const [getUserWallet, loading, data] = useCustomQuery({
    query: GET_USER_WALLET,
    onError: (err: any) => {
      if (err) {
        return push(`/${AdminRouteName.notFoundRoute}`);
      }
    },
    onData: () => {},
  });

  useEffect(() => {
    if (data?.getUserWallet) {
      setPayload(data?.getUserWallet);
    }
  }, [data]);

  const fetchCustomerWallet = useCallback(
    () => getUserWallet({ variables: { userId: customerId } }),
    [customerId],
  );

  useEffect(() => {
    fetchCustomerWallet();
  }, []);

  return (
    <>
      <WalletDetailsCard
        walletAmount={payload?.balance}
        isLoading={loading}
        handleWalletRefresh={fetchCustomerWallet}
      />
      <WalletDetailsRecord
        defaultUrl={`/customers/customer-details/${customerId}/wallet`}
        userId={customerId}
      />
    </>
  );
};

export default Wallet;
